import { LegalEntity } from '../types';

export function isDomestic(legalEntity: LegalEntity, regionCode: string) {
  return (
    legalEntity.incorporation_region?.code.toLowerCase() ===
    regionCode.toLowerCase()
  );
}
